import { LatLngBounds } from "leaflet";
import React, { useState } from "react";
import { useMap } from "react-leaflet";
import PlayBackFunctionsSettings from "./PlayBackFunctionsSettings";
import trans from "../../../../utils";

export default function PlayBackFunctions({
  setPlayAllHist,
  mainhistorypositions,
  settings,
  setSettings,
}) {
  const map = useMap();
  const [show, setShow] = useState(false);
  const handleOverviewZoom = () => {
    if (mainhistorypositions.length >= 2) {
      const bounds = new LatLngBounds(
        [mainhistorypositions[0].latitude, mainhistorypositions[0].longitude],
        [
          mainhistorypositions[mainhistorypositions.length - 1].latitude,
          mainhistorypositions[mainhistorypositions.length - 1].longitude,
        ]
      );
      map.fitBounds(bounds, {
        padding: [50, 50],
        maxZoom: 17,
      });
    } else if (mainhistorypositions.length === 1) {
      map.setView(
        [mainhistorypositions[0].latitude, mainhistorypositions[0].longitude],
        13
      );
    } else {
      console.warn("No coordinates available to set map bounds.");
    }
  };
  const lang = localStorage.getItem("lang") || "en";
  return (
    <div className="flex-between history-playback-functions">
      <div
        className="history-playback-functions-container"
        onClick={() => setPlayAllHist(true)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/MediaPlay.svg`}
          alt="play"
        />

        <div
          className={`history-playback-functions-tip ${
            lang === "ar"
              ? "history-playback-functions-tip-rtl"
              : "history-playback-functions-tip-ltr"
          }`}
        >
          <div className="text-center">{trans("Play all history")}</div>
        </div>
      </div>
      <div
        className="history-playback-functions-container"
        onClick={handleOverviewZoom}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/MyLocation.svg`}
          alt="location"
        />
        <div
          className={`history-playback-functions-tip ${
            lang === "ar"
              ? "history-playback-functions-tip-rtl"
              : "history-playback-functions-tip-ltr"
          }`}
        >
          <div className="text-center">{trans("Overview of all history")}</div>
        </div>
      </div>
      <div className="history-playback-functions-container">
        <img
          src={`${process.env.PUBLIC_URL}/assets/Download2.svg`}
          alt="export"
        />
        <div
          className={`history-playback-functions-tip ${
            lang === "ar"
              ? "history-playback-functions-tip-rtl"
              : "history-playback-functions-tip-ltr"
          }`}
        >
          <div className="text-center">{trans("Export selected")}</div>
        </div>
      </div>
      <div
        className="history-playback-functions-container"
        onClick={() => setShow(!show)}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/MiniSettings.svg`}
          alt="settings"
        />
        <div
          className={`history-playback-functions-tip ${
            lang === "ar"
              ? "history-playback-functions-tip-rtl"
              : "history-playback-functions-tip-ltr"
          }`}
        >
          <div className="text-center">{trans("More actions")}</div>
        </div>
      </div>
      {show && (
        <PlayBackFunctionsSettings
          settings={settings}
          setSettings={setSettings}
          mainhistorypositions={mainhistorypositions}
        />
      )}
    </div>
  );
}
